import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Modal from 'react-modal'
import { useAlert } from 'react-alert'

import { getLabs } from '../../Utils/api'
import { addEventNameWithParams, logEvent } from '../../Utils/utils'
import ImgProduct from '../../assets/img/prescription.png'
import ImgLab from '../../assets/img/lab_disabled.svg'
import Line from '../../assets/img/Line.svg'
import ImgLoading from '../../assets/img/loading_bar.gif'

function CardLab(props) {
  const alert = useAlert()
  const [modalDetailIsOpen, setDetailIsOpen] = useState(false)
  const [dataDetail, setdataDetail] = useState(null)

  function closeModalDetail() {
    setDetailIsOpen(false)
  }
  function openModalDetail(data, params) {
    addEventNameWithParams('modal-contact-laboratory', {
      labName: data.name,
      labId: data.id,
    })
    setdataDetail({ ...data, type: params.type })
    setDetailIsOpen(true)
  }
  function onAfterOpen(props) { }

  function clickElement(e, link, type) {
    logEvent('Laboratory Contacted', {
      "Origin": "Contact Lab",
      "Lab Name": dataDetail.name,
      "Lab Id": dataDetail.id,
      "Contact Type": type
    })
    if (type === 'web') {
      e.preventDefault()
      return window.open(link)
    }
  }

  return (
    <>
      <Modal
        isOpen={modalDetailIsOpen}
        onAfterOpen={onAfterOpen(props)}
        onRequestClose={closeModalDetail}
        className="modal-custom"
        overlayClassName="modal-custom-bg"
        contentLabel="Modal1"
        ariaHideApp={false}>
        <button className="btn-circle-close" onClick={closeModalDetail}>
          <i className="icon-close"></i>
        </button>
        {dataDetail && (
          <div className="d-flex flex-column align-items-center justify-content-center">
            <div className="content-img mb-3">
              <img
                src={
                  ![undefined, null].includes(dataDetail?.image)
                    ? dataDetail.image
                    : ImgProduct
                }
                className="img-product"
              />
            </div>
            <h2 className="title-primary--xl text-center">{dataDetail.name}</h2>
            {dataDetail.type === 'phone' && (
              <a
                id="gtm-webapp-pro-laboratory-phone"
                href={`tel: ${dataDetail.phone}`}
                onClick={(e) => clickElement(e, null, 'phone')}
                className="txt-paragraph--light color-lilac">
                {dataDetail.phone}
              </a>
            )}
            {dataDetail.type === 'email' && (
              <a
                id="gtm-webapp-pro-laboratory-email"
                href={`mailto: ${dataDetail.email}`}
                onClick={(e) => clickElement(e, null, 'email')}
                className="txt-paragraph--light color-lilac ">
                {dataDetail.email}
              </a>
            )}
            {dataDetail.type === 'link' && (
              <a
                id="gtm-webapp-pro-laboratory-link"
                href={''}
                onClick={(e) => clickElement(e, dataDetail.link, 'web')}
                className="txt-paragraph--light color-lilac ">
                Contactar en sitio web
              </a>
            )}
          </div>
        )}
      </Modal>
      {props.data.map((item, key) => {
        if ([undefined, null, '', 0].includes(item?.accept_contact)) {
          return false
        }

        return (
          <div
            key={key}
            className="d-flex justify-content-between align-items-center w-100 mb-3"
          >
            <div className="d-flex align-items-center">
              <div className="content-img mr-3">
                <img
                  src={
                    ![undefined, null].includes(item?.image)
                      ? item.image
                      : ImgLab
                  }
                  className="img-product"
                />
              </div>
              <h3 className="txt-paragraph">{item.name}</h3>
            </div>
            <div className="d-flex justify-content-end">
              {![undefined, null, ''].includes(item?.link) ? (
                <button
                  id={`gtm-webapp-laboratory-link-${item.id}`}
                  className="btn-circle"
                  onClick={() => openModalDetail(item, { type: 'link' })}>
                  <img
                    id={`gtm-webapp-laboratory-link-icon-${item.id}`}
                    src={Line}
                    className="img-lab-icon"
                    alt="Yapp"
                  />
                </button>
              ) :
                <>
                  {![undefined, null, ''].includes(item?.phone) && (
                    <button
                      id={`gtm-webapp-laboratory-phone-${item.id}`}
                      className="btn-circle mr-2"
                      onClick={() => openModalDetail(item, { type: 'phone' })}>
                      <i
                        id={`gtm-webapp-laboratory-phone-icon-${item.id}`}
                        className="icon-phone-pro"></i>
                    </button>
                  )}
                  {![undefined, null, ''].includes(item?.email) && (
                    <button
                      id={`gtm-webapp-laboratory-email-${item.id}`}
                      className="btn-circle"
                      onClick={() => openModalDetail(item, { type: 'email' })}>
                      <i
                        id={`gtm-webapp-laboratory-email-icon-${item.id}`}
                        className="icon-send-pro"></i>
                    </button>
                  )}
                </>
              }
            </div>
          </div>
        )
      })}
    </>
  )
}

function Laboratory() {
  const history = useHistory()
  const [labs, setLabs] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(async () => {
    setLoading(true)
    let result = await getLabs()
    if (!result) {
      return history.push('/error')
    }

    setLabs(result?.data)
    setLoading(false)
  }, [])

  function goBack() {
    history.goBack()
  }

  return (
    <>
      {loading && (
        <img className="w-100" style={localStyle.loadBar} src={ImgLoading} />
      )}
      <div className='py-3 px-3'>
        <div className="content-responsive mx-auto d-flex justify-content-between ">
          <div className="breadcrumbs c-pointer" onClick={goBack}>
            <a className="d-flex align-items-center">
              <i className="icon-chevron-right icon-reverse"></i>
            </a>
            <span className="title-primary--regular line-14">Volver</span>
          </div>
        </div>
      </div>
      <div className="flex-grow-1 mt-md-2 px-3">
        <div className="w-100 ">
          <div className="content-responsive mx-auto pt-4">
            <h2 className="title-primary--xxl ">Contactar Laboratorios</h2>
            <div className="py-12">
              <CardLab data={labs} />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const localStyle = {
  loadBar: {
    height: '0.5rem',
  },
}

export default Laboratory
